import { css } from '@/styled-system/css';

export const compactAddMessageOuterStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const compactAddMessageWrapperStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  width: '100%',
  gap: 'default',
});

export const compactAddMessageContentStyles = css.raw({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
});
